import { OrderedMap, Record, List, Map } from 'immutable';
import { erpNamesList, settingsTypes } from '@/domain/settings/constants';

export const erpsUpdateDataAdapter = (data, stateErps) =>
  erpNamesList.reduce(
    (
      result,
      key, // eslint-disable-line
    ) => (data[key] ? { ...result, [key]: { ...data[key], details: OrderedMap(data[key]) } } : result),
    stateErps,
  );

export const ERPSettingsBooleanFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: false,
  type: 'boolean',
});

export const ERPSettingsTextFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: '',
  type: 'text',
});

export const ERPSettingsFloatFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: '',
  type: 'float',
});

export const ERPSettingsNumberFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: '',
  type: 'number',
});

export const ERPSettingsIntFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: '',
  max: null,
  min: null,
  type: 'int',
});

export const ERPSettingsListFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: '',
  options: new Map(),
  type: 'list',
  deletable: false,
  clearable: false,
});

export const ERPSettingsDynamicListFactory = new Record({
  group: null,
  name: '',
  label: '',
  value: '',
  display_value: '',
  options_function: '',
  type: 'dynamic_list',
  deletable: false,
  clearable: false,
});

export const ERPSettingsFileFactory = new Record({
  group: null,
  label: '',
  name: '',
  type: 'file',
  formats: new List(),
  value: '',
});

export const ERPSettingsFTPConnectionFactory = new Record({
  group: null,
  label: '',
  mandatory: false,
  name: '',
  type: 'ftp_connection',
  value: '',
});

export const ERPSettingsTimeSelectorFactory = new Record({
  group: null,
  label: '',
  mandatory: false,
  indexes_update_date: null,
  is_sync_running: false,
  name: '',
  type: 'indexes_sync_time',
  value: {
    hours: 0,
    timezone: '',
  },
});

export const ERPSettingsPriorityCustomerApiConnectionFactory = new Record({
  group: null,
  label: '',
  mandatory: false,
  name: '',
  type: 'priority_customer_api_connection',
  value: '',
});

export const currentERPSettingsAdapter = (data) => {
  // eslint-disable-next-line no-bitwise
  const allowedSettings = data.filter((item) => ~Object.keys(settingsTypes).indexOf(item.type));
  // $FlowFixMe it's exhaustive!
  return List(
    // eslint-disable-next-line array-callback-return
    allowedSettings.map((settingsItem) => {
      // Null coming from API response after user deletes value
      // makes MUI input uncontrollled so its value is not cleared and
      // makes placeholder overlap with value
      if (settingsItem.value === null) settingsItem.value = '';
      // eslint-disable-next-line default-case
      switch (
        settingsItem.type // eslint-disable-line default-case
      ) {
        case 'boolean':
          return ERPSettingsBooleanFactory(settingsItem);
        case 'text':
          return ERPSettingsTextFactory(settingsItem);
        case 'float':
          return ERPSettingsFloatFactory(settingsItem);
        case 'number':
          return ERPSettingsNumberFactory(settingsItem);
        case 'int':
          return ERPSettingsIntFactory(settingsItem);
        case 'list': {
          const listSettingRecord = ERPSettingsListFactory(settingsItem);
          if (settingsItem.options) {
            return listSettingRecord.set('options', Map(settingsItem.options));
          }
          return listSettingRecord;
        }
        case 'dynamic_list':
          return ERPSettingsDynamicListFactory(settingsItem);
        case 'file':
          return ERPSettingsFileFactory(settingsItem);
        case 'ftp_connection':
          return ERPSettingsFTPConnectionFactory(settingsItem);
        case 'priority_customer_api_connection':
          return ERPSettingsPriorityCustomerApiConnectionFactory(settingsItem);
        case 'indexes_sync_time':
          return ERPSettingsTimeSelectorFactory(settingsItem);
      }
    }),
  );
};

export const isCompanyConnected = (erps) => erps.valueSeq().some((erp) => erp.status === 'connected');
